import { Component, PipeTransform, Pipe, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { QuestionareService } from './questionare.service';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }
  transform(url:string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}

@Component({
  selector: 'app-questionare',
  templateUrl: './questionare.component.html',
  styleUrls: ['./questionare.component.less'],
})
export class QuestionareComponent implements OnInit {

  constructor(private _questionareService: QuestionareService) { }

  formUrl: string="/questionare/";
  ngOnInit(): void {
    console.log("FormUrl"+this.formUrl);
    var url = window.location.href;
    var arr = url.split("/");
    var result = arr[0] + "//" + arr[2]
    console.log("Current host to connect to - " + result);


    //this is for dev and prod setup may not work on local setup.
    this.formUrl=result + this.formUrl+"?caseId="+this._questionareService.caseId+"&patientId="+this._questionareService.patientId;
    //for local setup please use below url
    //this.formUrl="https://dev1.iylon.com" + this.formUrl+"?caseId="+this._questionareService.caseId+"&patientId="+this._questionareService.patientId;
    console.log(this.formUrl);
    console.log("CaseId: "+this._questionareService.caseId);
    console.log("PatientId: "+this._questionareService.patientId);
  }

}
